import { Link } from 'react-router-dom'
import { Button, InlineError, Input } from 'avo-ui'
import ReCAPTCHA from 'react-google-recaptcha'
import CONFIG from 'configs/env'

export const ForgotPassword = ({
    recaptchaRef,
    forgotPasswordDetail,
    onChangeForm,
    errorForm,
    isLoading,
    onSubmit,
}) => {
    return (
        <div className={'w-screen h-screen flex flex-col space-y-8 items-center justify-center bg-primary-100'}>
            <Link to={'/'}>
                <p className={'font-bold text-lg text-white'}>MSBB ADMIN DASHBOARD</p>
            </Link>
            <div
                className={
                    'w-[480px] flex flex-col items-center space-y-10 px-16 py-6 border text-blue-90 bg-white rounded-xl shadow-xl'
                }
            >
                <p className={'text-4xl'}>Forgot Password</p>
                <div className={'w-full flex flex-col space-y-3'}>
                    <div className={'font-semibold text-blue-90'}>Email</div>
                    <Input
                        className={'flex-1'}
                        name={'email'}
                        placeholder={'Masukkan email'}
                        value={forgotPasswordDetail?.email}
                        onChange={onChangeForm}
                    />
                    <InlineError className={'mt-2'} message={errorForm?.email} />
                </div>
                <div className={'flex flex-col space-y-6'}>
                    <ReCAPTCHA
                        ref={recaptchaRef}
                        sitekey={CONFIG.GOOGLE_RECAPTCHA_SITE_KEY}
                        onChange={(value) => onChangeForm({ name: 'recaptcha_token', value })}
                        onExpired={() => onChangeForm({ name: 'recaptcha_token', value: null })}
                    />
                    <InlineError className={'mt-2 mx-auto'} message={errorForm?.recaptcha_token} />
                </div>
                <div className={'px-6 py-3 flex justify-center'}>
                    <Button className={'w-[200px]'} title={'Submit'} loading={isLoading} onClick={onSubmit} />
                </div>
            </div>
        </div>
    )
}
